import { Button } from '@chakra-ui/react';
import ExpandMore from '@mui/icons-material/ExpandMore';
import styled from 'styled-components';

export const CustomExpandMore = styled(ExpandMore)`
  width: 13px !important;
  margin-left: 5px;
`;

export const Value = styled.div`
  margin-left: 2px;
  display: flex;
  align-items: center;
`;

export const ConditionButton = styled.button<{ isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  margin-left: 2px;
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'initial')};
  height: 21px;
  &:hover {
    background-color: ${(props) => props.theme.colors['secondary-30']};
    border-radius: 2px;
  }
`;

export const DeleteButton = styled(Button)`
  position: absolute !important;
  bottom: -20px;
  right: -100px;
  z-index: 2;
  svg {
    fill: #ef5b5b;
  }
  color: #ef5b5b;
`;

export const Text = styled.p<{ isBold?: boolean; isCapitalized?: boolean }>`
  font-size: 14px;
  line-height: 21px;
  display: inline-block;
  font-weight: ${(props) => (props.isBold ? '600' : '400')};
  text-transform: ${(props) => (props.isCapitalized ? 'capitalize' : 'initial')};
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const FilterTextArea = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const DeleteFilterButton = styled.button`
  line-height: 0;
  margin-left: 10px;
`;
